import React, { useState } from "react";

import $ from "jquery";
import { Button, Radio, Input, Card } from "semantic-ui-react";

import ModalPayPal from "../../paypal/ModalPaypal";
import { toast } from "react-toastify";

function ButtonSupport(props) {
    const [visible, setVisible] = useState(false);
    const [inputDisabled, setInputDisabled] = useState(true);
    const [priceValue, setPriceValue] = useState("10");
    const [price, setPrice] = useState("10");

    function handleChangeModal(value) {
        setVisible(value);
    }

    function changeStatusModal() {
        if (priceValue === "custom") {
            const priceInput = $(".input-price-paypal").children("input").val();
            if (priceInput) {
                if (priceInput > 0 && priceInput < 1001) {
                    setPrice(priceInput);
                    setVisible(true);
                } else {
                    toast.error((props.lang === "es") ? 'Error en el precio' : 'Price error', {
                        position: "top-center",
                        autoClose: 2500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            } else {
                toast.error((props.lang === "es") ? 'Campo vacio' : 'Empty field', {
                    position: "top-center",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        } else {
            setPrice(priceValue);
            setVisible(true);
        }
    }

    function handleChangeRadioButton(e) {
        const value = $(e.target).prev().val();
        if (value === "custom") {
            setInputDisabled(false);
            setPriceValue("custom");
        } else {
            setInputDisabled(true);
            setPriceValue(value);
        }
    }

    function handleChangeInputPrice(e) {
        if (e.target.value < 1) {
            e.target.value = 1;
        } else if (e.target.value > 1000) {
            e.target.value = 1000;
        }
    }

    return (
        <div className="col">
            <p style={{ margin: "auto auto 0.6em" }}>{props.data.description[props.lang]}</p>
            <Card className="option-card-settings paypal-options" fluid color="red" header={
                <>
                    <Radio
                        label='5€'
                        name='radioGroup'
                        value='5'
                        checked={priceValue === '5'}
                        onChange={handleChangeRadioButton}
                    />
                    <Radio
                        label='10€'
                        name='radioGroup'
                        value='10'
                        checked={priceValue === '10'}
                        onChange={handleChangeRadioButton}
                    />
                    <Radio
                        label='20€'
                        name='radioGroup'
                        value='20'
                        checked={priceValue === '20'}
                        onChange={handleChangeRadioButton}
                    />
                    <Radio
                        label=''
                        name='radioGroup'
                        value='custom'
                        checked={priceValue === 'custom'}
                        onChange={handleChangeRadioButton}
                    />
                    <Input
                        type="number"
                        className="input-price-paypal"
                        disabled={inputDisabled}
                        label={{ basic: true, content: '€' }}
                        labelPosition='right'
                        placeholder='Enter price'
                        onChange={handleChangeInputPrice}
                    />
                </>
            } />
            <Button primary content={props.data.content[props.lang]} size="large" onClick={changeStatusModal} />
            {(visible) ? <ModalPayPal price={price} onChange={handleChangeModal} lang={props.lang} /> : null}
        </div>
    );
}

export default ButtonSupport;